import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.working-slots')
  .factory('WorkingSlotsAPI', WorkingSlotsAPI);

function WorkingSlotsAPI(): BringozApi {
  return {
    base: `/workingslot`,
    infiniteScroll: {
      address: `/workingslot`,
      cmd: 'GET'
    },
    actions: {
      get: {
        address: '',
        cmd: 'GET',
        updateable: true
      },
      create: {
        address: '',
        cmd: 'PUT',
        updateable: true
      },
      updateOne: {
        address: '{id}',
        cmd: 'POST',
        updateable: true
      },
      deleteOne: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: true
      },
      validateWorkingSlots: {
        address: 'validate',
        cmd: 'POST',
        updateable: true
      },
    }
  }
}
